import React from 'react';
import { t } from '../../../../utils/i18n';
import { Loader } from '../../../Loader';
import s from './styles.scss';

export const RemovalLoading = () => (
  <>
    <div className={s.loaderContainer}>
      <Loader size="medium" />
    </div>
    <div className={s.text}>{t('app.card.details.remove.loading')}</div>
  </>
);
RemovalLoading.displayName = 'RemovalLoading';
